import { Navigate } from "react-router-dom";
import { LayoutRouter } from "../pages/layout/Layout";
import { useSelector } from 'react-redux';
import { RootState } from '../store';

const PrivateRoute = () => {
	const { authToken } = useSelector((state: RootState) => state.auth);
	return authToken ? <LayoutRouter /> : <Navigate to="/" replace />
}

export default PrivateRoute;